import type { ActionsObservable } from 'redux-observable';
import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { HandleAjaxError } from '@helpcenter/flags';
import { handleAjaxError } from '@helpcenter/flags';
import { subscribe, unsubscribe } from 'rest/notification';
import type { ChangeSubscription, ChangeSubscriptionSuccess } from 'state/actions/request-details';
import { CHANGE_SUBSCRIPTION, changeSubscriptionSuccess } from 'state/actions/request-details';

export const changeRequestSubscriptionEpic: Epic<ChangeSubscription, ChangeSubscriptionSuccess | HandleAjaxError> = (
    action$: ActionsObservable<ChangeSubscription>
) => {
    return action$.ofType(CHANGE_SUBSCRIPTION).mergeMap((changeSubscriptionAction) => {
        const { shouldSubscribe, requestId, requestKey } = changeSubscriptionAction.payload;
        const restCall = shouldSubscribe ? subscribe : unsubscribe;
        return restCall(requestId)
            .map(() => {
                return changeSubscriptionSuccess(requestKey, shouldSubscribe);
            })
            .catch((error: AjaxError) => {
                return Observable.of(handleAjaxError(error));
            });
    });
};
